/* SoloSuccess theme — small enhancements; every page works without them. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Mobile menu
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var bar = btn.closest('.ss-header__bar');
        var open = bar.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Search panel
    document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var input = panel.querySelector('input'); if (input) input.focus(); }
      });
    });

    // Product gallery thumbnails
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          main.src = thumb.getAttribute('data-src');
          main.srcset = thumb.getAttribute('data-srcset') || '';
          main.alt = thumb.getAttribute('data-alt') || '';
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });
          thumb.setAttribute('aria-pressed', 'true');
        });
      });
    });

    // Variant picker: option pills -> variant id, price and button state
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var button = form.querySelector('[data-add-button]');
      var labels = form.querySelectorAll('[data-option-value]');

      function update() {
        var chosen = [];
        form.querySelectorAll('[data-option-group]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          chosen.push(checked ? checked.value : null);
        });
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
        form.querySelectorAll('[data-option-group]').forEach(function (group, i) {
          var label = group.querySelector('[data-option-current]');
          if (label) label.textContent = chosen[i] || '';
        });
        if (!match) {
          button.disabled = true; button.textContent = button.getAttribute('data-unavailable');
          return;
        }
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        button.disabled = !match.available;
        button.textContent = match.available ? button.getAttribute('data-add') : button.getAttribute('data-sold-out');
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
      form.addEventListener('change', function (e) { if (e.target.matches('[data-option-group] input')) update(); });
    });

    // Quantity steppers
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var min = parseInt(input.min || '0', 10);
          input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  });
})();
